import script from "./MyAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccount.vue?vue&type=script&setup=true&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=20d639b9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d639b9"]])

export default __exports__